import TextareaAutosize from '@mui/material/TextareaAutosize'

import { SidebarLayoutDrawer } from '../../../theme/components/SidebarLayoutDrawer'
import type { JobSchedule } from '../../types/JobSchedule'

interface Props {
  jobSchedule: JobSchedule
  open: boolean
  onClose: () => void
}

const MESSAGE_INDENT = 2

const parse = (content: Record<string, any>) =>
  content && JSON.stringify(content, null, MESSAGE_INDENT)

export const JobScheduleData = ({ jobSchedule, open, onClose }: Props) => {
  const { name, data } = jobSchedule

  return (
    <SidebarLayoutDrawer
      open={open}
      onClose={onClose}
      title={`Data van ${name}`}
    >
      <TextareaAutosize
        minRows={10}
        maxRows={40}
        value={parse(data)}
        style={{ width: '100%' }}
      />
    </SidebarLayoutDrawer>
  )
}
